import React from "react";
import { FaCapsules, FaClinicMedical, FaCogs, FaHandsHelping, FaRegFileAlt, FaRegHeart, FaRegHospital, FaRegIdCard, FaRegLightbulb, FaRegMoneyBillAlt } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import { IAgent } from "./agents.data";

interface Testimony {
  image: string;
  personName: string;
  personTitle: string;
  businessName: string;
  paragraph: string;
  partnerLogo: string;
  buttonLabel: string;
}

interface Feature {
  title: string;
  subtitle: string;
  description: string;
  image: string;
  href: string;
  buttonText: string;
  agent: IAgent
}

interface CallToAction {
  title: string;
  paragraph: string;
  buttonLabel: string;
}

export interface ICategory {
  id: string;
  title: string;
  subtitle: string;
  icon: React.ReactNode
}
export interface ISegment {
  title: string;
  subtitle: string;
  video: string;
  testimony: Testimony;
  feature: Feature[];
  callToAction: CallToAction;
  categories: string[];
}

export const segmentsIds = [
  "health-care",
  "clinics",
  "health-insurers",
  "hospitals-labs",
  "human-resources",
  "pharma-industry"
]

export const segmentsIconsMap: Record<string, React.ReactNode> = {
  "health-care": <FaRegHeart />,
  "clinics": <FaClinicMedical />,
  "health-insurers": <FaRegIdCard />,
  "hospitals-labs": <FaRegHospital />,
  "human-resources": <FaUsers />,
  "pharma-industry": <FaCapsules />,
}

export const categoryIconMap: Record<string, React.ReactNode> = {
  assistenciais: <FaHandsHelping className="text-xl" />,
  administrativos: <FaRegFileAlt className="text-xl" />,
  informacionais: <FaRegLightbulb className="text-xl" />,
  operacionais: <FaCogs className="text-xl" />,
  financeiros: <FaRegMoneyBillAlt className="text-xl" />,
  assistance: <FaHandsHelping className="text-xl" />,
  administrative: <FaRegFileAlt className="text-xl" />,
  informational: <FaRegLightbulb className="text-xl" />,
  operational: <FaCogs className="text-xl" />,
  financial: <FaRegMoneyBillAlt className="text-xl" />,
}